import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs';
import { Banche } from 'my-lib-sanfelici/my-lib-sanfelici';
import { BancheService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-banche-combo',
  templateUrl: './banche-combo.component.html',
  styleUrls: ['./banche-combo.component.css']
})
export class BancheComboComponent implements OnInit {
banche: Observable<Banche[]>;
@Input() banca: Banche;
@Output() onbanca = new EventEmitter<Banche>();
  constructor(
    private bancheservice: BancheService
  ) { }
  onChange() {
    this.onbanca.emit(this.banca);
}
  ngOnInit() {
    this.banche = this.bancheservice.list();
  }

}
